/* eslint-disable @next/next/no-img-element */
import { useState, useRef, useEffect } from "react";
import ModalSelectImage from 'components/tao-bai-viet/noi-dung/image/modalSelectImage';
import ImageComponentWithTag from 'components/cong-dong/chi-tiet/imageComponentWithTag';
import Slider from "react-slick";
import {isEmpty} from 'lodash';

export default function EditorComponent({ editorId, onUploadImage, isSingleEditor, noNeedTag = false, thumbnail_file_id: thumbnail_file_id_parent = null, setThumbnail = null, oldImage = null }) {
    const [thumbnail_file_id, setthumbnail_file_id] = useState(thumbnail_file_id_parent);
    const [displayModalSelectImage, setDisplayModalSelectImage] = useState(false);
    const [displayModalTag, setDisplayModalTag] = useState(false);
    const [imageSelect, setImageSelect] = useState(oldImage || []);
    const [imageTag, setImageTag] = useState({});

    const [clickImage, setClickImage] = useState(1);
    const settingsSlideHead = {
        arrows: true,
        dots: false,
        fade: true,

        beforeChange: (current, next) => setClickImage(current + 1),
        afterChange: current => setClickImage(current + 1)
    };

    const openModal = () => {
        setDisplayModalSelectImage(true);
    };

    const removecImage = (image) => {
        if (!image) return;
        const imageListAfterRemove = imageSelect.filter(x => x.id !== image.id);

        setImageSelect(imageListAfterRemove);
    };

    useEffect(() => {
        if (!oldImage) return;
        setImageSelect(oldImage);
    }, [oldImage]);

    useEffect(() => {
        if (!thumbnail_file_id_parent) return;
        setthumbnail_file_id(thumbnail_file_id_parent);
    }, [thumbnail_file_id_parent]);

    //Update trạng thái của Parent khi select ảnh
    useEffect(() => {
        onUploadImage(editorId, imageSelect);

        if (isEmpty(imageSelect)) {
            setThumbnail({ thumbnail_file_id: null });
            return;
        }

        if (thumbnail_file_id === null && !isEmpty(imageSelect) && setThumbnail) {
            setThumbnail({ thumbnail_file_id: imageSelect[0].id });
        }

        if (!imageSelect.some(x => x.id == thumbnail_file_id)) {
            setThumbnail({ thumbnail_file_id: imageSelect[0].id });
        }
    }, [imageSelect]);

    return <div>
        {isSingleEditor && <div className="createPost-upFile mt-3">
            <label className="custom-control custom-file pl-0" onClick={openModal}>
                <span className="btn">
                    {/* <input className="custom-file-input" type="file" /> */}
                    <img src="/images/icon-uploadfile.svg" alt="" />
                    <p className="tlt">Thêm ảnh</p>
                    <p className="note">Có thể chọn 1 / nhiều ảnh</p>
                </span>
            </label>
        </div>}
        <ModalSelectImage displayModalP={displayModalSelectImage} setDisplayModalP={setDisplayModalSelectImage} imageSelectP={imageSelect} setImageSelectP={setImageSelect}/>
        {/* <ModalTagImage displayModalTag={displayModalTag} setDisplayModalTag={setDisplayModalTag} imageTag={imageTag}/> */}
        {
            !noNeedTag && imageSelect.map((image, index) => {
                return (
                    <div key={index} className="createPost-thumb mt-4">
                        <div className="thumb sliderPhoto" style={{ position: 'relative' }}>
                            {/* <img src={image.storage_url} alt="" style={{ width: '100%', height: 'auto'}}/> */}
                            <ImageComponentWithTag 
                                image={image}
                                isCreate={true}
                                thumbnail_file_id={thumbnail_file_id}
                                setThumbnail={setThumbnail}/>
                            <span className="createPost-close" onClick={() => removecImage(image)}>
                                <img src="/images/icon-close01.svg" alt="" />
                            </span>
                        </div>
                    </div>
                );
            })
        }
        {/* {
            noNeedTag && <>
                <div className="detail-content display-arrow">
                    {!isEmpty(imageSelect) && <Slider {...settingsSlideHead}>
                        {imageSelect.map((image, index) => {
                            return <div key={index} className="img-detail wrap-next-image-not-crop" style={{ position: 'relative' }}>
                                <img src={image.storage_url} alt="" />
                            </div>;
                        })}
                    </Slider>}
                    {!isEmpty(imageSelect) && <>
                        <span className="pagingInfo">
                            {clickImage}/{imageSelect.length || 1}
                        </span>
                        <span className="createPost-close" style={{ cursor: 'pointer', position: 'absolute', top: 5, right: 5 }} onClick={() => {
                            removecImage(imageSelect[clickImage - 1]);
                            if(clickImage >= imageSelect.length && clickImage > 1) setClickImage(clickImage - 1);
                        }}>
                            <img src="/images/icon-close01.svg" alt="" />
                        </span>
                    </>
                    }
                </div>
            </>
        } */}
        {
            noNeedTag && <>
                <div className="detail-content">
                    {!isEmpty(imageSelect) &&
                        imageSelect.map((image, index) => {
                            return <div key={index} className="img-detail wrap-next-image mt-4" style={{ position: 'relative' }}>
                                <img src={image.storage_url} alt="" />
                                <span className="createPost-close" style={{ cursor: 'pointer', position: 'absolute', top: 5, right: 5 }} onClick={() => {
                                    removecImage(imageSelect[clickImage - 1]);
                                    if (clickImage >= imageSelect.length && clickImage > 1) setClickImage(clickImage - 1);
                                }}>
                                    <img src="/images/icon-close01.svg" alt="" />
                                </span>
                            </div>;
                        })
                    }
                </div>
            </>
        }
        {!isSingleEditor && <button className="p-1 mt-2" style={{ border: '1px solid rgba(0, 0, 0, .2)', width: '100%' }} onClick={openModal}>+ Thêm ảnh</button>}
    </div>;
}
